/**
 * Normalizes draft synonym inputs for persistence (trim + drop empties).
 */
export function normalizeSynonymDrafts(values: string[]): string[] {
  return values.map((value) => value.trim()).filter(Boolean);
}
